import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { FiLock, FiX } from 'react-icons/fi';
import api from '../../../api/api';
import { SetUser } from '../../../actions/SetUser';
import { toast } from '../Toast';

interface Props {
    onClose: () => void;
}

const ChangePasswordModal: React.FC<Props> = ({ onClose }) => {
    const dispatch = useDispatch();
    const [current, setCurrent] = useState('');
    const [next, setNext] = useState('');
    const [confirm, setConfirm] = useState('');
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState('');

    const mismatch = confirm.length > 0 && next !== confirm;
    const canSave = current.length > 0 && next.length > 0 && next === confirm && !saving;

    const save = async () => {
        setError('');
        setSaving(true);
        try {
            const result = await api().changeOwnPassword(current, next);
            dispatch(SetUser(result.user));
            toast.success('Password changed. Other devices have been signed out');
            onClose();
        } catch (err: any) {
            setError(err?.response?.data || 'Could not change password, please try again');
            setSaving(false);
        }
    };

    return <div className="modal-overlay" onClick={onClose}>
        <div className="change-password-modal" role="dialog" aria-modal="true" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
                <span className="icon-tile"><FiLock /></span>
                <div>
                    <h2>Change Password</h2>
                    <p>Every other device will be signed out</p>
                </div>
                <button type="button" className="close" aria-label="Close" onClick={onClose}><FiX /></button>
            </div>

            <form className="modal-body" onSubmit={e => { e.preventDefault(); if (canSave) save(); }}>
                <label className="field">
                    <span className="label">Current password</span>
                    <input type="password" autoComplete="current-password" value={current} onChange={e => setCurrent(e.target.value)} autoFocus />
                </label>
                <label className="field">
                    <span className="label">New password</span>
                    <input type="password" autoComplete="new-password" value={next} onChange={e => setNext(e.target.value)} />
                </label>
                <label className="field">
                    <span className="label">Confirm new password</span>
                    <input type="password" autoComplete="new-password" value={confirm} onChange={e => setConfirm(e.target.value)} />
                </label>
                {mismatch && <p className="error">The new passwords don't match</p>}
                {error && !mismatch && <p className="error">{error}</p>}
                {/* hidden submit so Enter works */}
                <button type="submit" hidden />
            </form>

            <div className="modal-footer">
                <button type="button" className="link" onClick={onClose}>Cancel</button>
                <button type="button" className="btn-primary" onClick={save} disabled={!canSave}>Change Password</button>
            </div>
        </div>
    </div>;
};

export default ChangePasswordModal;
